// extracted by mini-css-extract-plugin
export default {"zoomControls":"Mua-z","zoomControlButton":"Nua-z","zoomBanner":"Oua-z","bannerButton":"Pua-z","imageButton":"Qua-z","zoom":"Rua-z","zoomContent":"Sua-z"};